import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const getInProgressTranslation = (currentAction: ModuleCommandEnum) => {
  let resultTranslation: string | null = null;

  switch (currentAction) {
    case ModuleCommandEnum.UP:
      return "action.inProgress.mounting";
    case ModuleCommandEnum.OPEN:
      return "action.inProgress.opening";
    case ModuleCommandEnum.CLOSE:
      return "action.inProgress.closing";
    case ModuleCommandEnum.DOWN:
      return "action.inProgress.downing";
  }

  if (!resultTranslation) {
    throw new Error("No translation found");
  }

  return resultTranslation;
};
